import { useState } from "react";
import { trackMetaEvent } from '../utils/MetaPixel';

const CheckoutButton = ({ items, formData, disabled, type }) => {
  const [loading, setLoading] = useState(false);

  const handlePayment = async () => {
    setLoading(true);
    try {
      // 1. Determinar si es un ebook para reutilizar la lógica
      const isEbook = type === 2;

      // 2. Preparar los datos y la clave para localStorage dinámicamente
      const storageKey = isEbook ? "ebookData" : "courseData";
      const dataToStore = {
        student: formData,
        send_inscription: false,
      };

      // Asignar propiedades específicas basadas en el tipo
      if (isEbook) {
        dataToStore.ebook_name = items[0]?.title;
        dataToStore.ebook_price = items[0]?.price;
        dataToStore.ebook_currency = items[0]?.currency;
        dataToStore.ebook_id = items[0]?.id;
      } else {
        dataToStore.course_name = items[0]?.title;
        dataToStore.course_id = items[0]?.id;
        dataToStore.course_type_title = items[0]?.typeTitle;
        dataToStore.currency = items[0]?.currency;
        dataToStore.program_price = items[0]?.price;
        dataToStore.payment_method = items[0]?.paymentMethod;
      }

      localStorage.setItem(storageKey, JSON.stringify(dataToStore));
      

      // 3. Crear la preferencia en PayU (los datos enviados son genéricos y no necesitan cambio)
      const preferenceResponse = await fetch(`${process.env.REACT_APP_HOST_BACKEND}/create_preference_mp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          nameHolder: formData.nameHolder,
          emailHolder: formData.emailHolder,
          product: items[0]?.title, 
          amount: items[0]?.price,
          currency: items[0]?.currency,
          productType: isEbook ? 'ebook' : items[0]?.type // Campo adicional para el backend
        }),
      });
      const resultPaymentDate = await preferenceResponse.json();

      // Redirigir a PayU (sin cambios)
      const form = document.createElement("form");
      form.method = "POST";
      form.action = resultPaymentDate.payuUrl;

      Object.keys(resultPaymentDate.data).forEach((key) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = resultPaymentDate.data[key];
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
      // No se desactiva el loading aquí porque la página va a redirigir

      // 4. Notificar al backend con un mensaje dinámico
      const notificationMessage = isEbook
        ? `El usuario está a punto de pagar un ebook por pasarela de pago.`
        : `El usuario está a punto de pagar un ${items[0]?.type} por pasarela de pago.`;

      await fetch(`${process.env.REACT_APP_HOST_BACKEND}/checkout_process`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          fullName: formData.fullName,
      //    identificationDocument: formData.identificationDocument,
          email: formData.email,
          phone: formData.phone,
          country: formData.country,
          product: items[0]?.title,
          amount: items[0]?.price,
          currency: items[0]?.currency,
          message: notificationMessage, // Mensaje personalizado
          productType: isEbook ? 'ebook' : items[0]?.type // Campo adicional para el backend
        }),
      });

    } catch (error) {
      console.error("Error en el proceso de pago:", error);
      setLoading(false); // Desactivar el estado de carga en caso de error
    }
  };

  return (
    <>
      {loading && (
        <div className="loading-spinner-container">
          <div className="loading-spinner"></div>
        </div>
      )}
      <button
        type="button"
        onClick={() => {
          handlePayment();
          // El evento de Meta Pixel es genérico y no necesita cambios
          trackMetaEvent('AddPaymentInfo', {
            customer_name: formData.fullName,
            customer_email: formData.email,
            customer_phone: formData.phone,
            content_name: items[0]?.title,
            content_ids: [items[0]?.id],
            currency: items[0]?.currency,
            value: items[0]?.price,
          });
        }}
        className="btn btn-primary py-3 px-5 hover:bg-blue-400 text-white font-extrabold rounded-xl shadow-lg transition text-sm"
        style={{ justifySelf: "center", opacity: disabled ? 0.5 : 1 }}
        disabled={disabled}
      >
        {loading ? "Cargando pasarela..." : "PAGAR AHORA"}
      </button>
    </>
  );
};

export default CheckoutButton;
